<template>
  <v-dialog persistent v-model="dialog" max-width="900">
    <v-card>
      <v-card-title class="border-bottom">
        Cari Hareket Detay - {{
          this.currentEFaturaProp ? this.currentEFaturaProp.currentName + ' ' + this.currentEFaturaProp.currentCode : ''
        }}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div v-if="!frameData" class="text-center">
          <v-overlay :value="!frameData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
            <div>Faturanız Yükleniyor Lütfen Bekleyiniz</div>
          </v-overlay>
        </div>
        <div class="d-flex">
          <div>
            <iframe v-if="showFrame" :src="frameData" style="width: 284%; height: 1000px;"></iframe>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {printView} from "../../../../helpers";
import {formattedDate} from "@/momentHelper";

export default {
  name: "CurrentActionEFatura",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    currentEFaturaProp: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState("current", ["currentActionDetailList", "currentActionDetailListHeaders", "currentActionDetailListLoading"]),
    ...mapState("order", ["erpOrdersELogo"]),

  },
  data() {
    return {
      dialog: false,
      perPage: 10,
      currentPage: 1,
      totalDebit: 0,
      totalCredit: 0,
      totalBalance: 0,
      showFrame: false,
      invoice:null,
      frameData:null,
    };
  },
  methods: {
    ...mapActions("current", ["fetchCurrentActionDetailList"]),
    ...mapMutations("current", ["setCurrentActionDetailList"]),
    ...mapActions("order", ["fetchErpOrderELogo"]),
    printView,
    formattedDate,
    closeDialog() {
      this.dialog = false;
    },
    async getPdfSrc(invoice) {
      this.frameData = `data:application/pdf;base64, ${invoice}`;
      this.showFrame=true;
    },
    async initCurrentErpOrderELogo() {
      await this.fetchErpOrderELogo({
        params: {
          ettn: this.currentEFaturaProp.ettn,
          CurrentType: this.currentEFaturaProp.currentType,
        },
        body: {},
      }).then((resp)=>{
        this.invoice = resp.data.data
        this.getPdfSrc(this.invoice)
      })
    },

  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (newVal)
        this.initCurrentErpOrderELogo();
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    }
  }
}
</script>

<style scoped>

</style>